import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for the whole `/approvals/*` subtree — same fix as
 * business `bookings.tsx` (Task 13's browser-smoke finding, see that
 * file's header comment): TanStack Router's flat file-route convention
 * makes any `approvals.tsx` alongside `approvals.$id.tsx` the PARENT layout
 * route, so every `/approvals/*` URL renders this component first and a
 * sibling only appears through this `<Outlet/>`. The list UI lives in
 * `approvals.index.tsx` (the exact-`/approvals` index route).
 */
export const Route = createFileRoute('/approvals')({
  component: ApprovalsLayout,
});

function ApprovalsLayout() {
  return <Outlet />;
}
